<template>
  <v-container fluid>
    <v-dialog persistent v-if="show" v-model="show" max-width="400">
      <v-card>
        <v-card-title>
          Corte de caja
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <div style="text-align:center;">
                <span style="font-weight:bold;font-size:16px;color:gray;">
                  Entrada efectivo:
                  <div v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 0">
                    {{ formateaMoneda(objetoInfoCorteDeCajaSucursal.ENTRADA_EFECTIVO) }} <br />
                  </div>
                  <div v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 1">
                    {{
                      formateaMoneda(
                        parseFloat(
                          objetoInfoCorteDeCajaSucursal.ENTRADA_EFECTIVO -
                            objetoInfoCorteDeCajaSucursal.SALIDA_EFECTIVO
                        )
                      )
                    }}
                    <br />
                  </div>
                  Salida efectivo:
                  <div v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 0">
                    {{ formateaMoneda(objetoInfoCorteDeCajaSucursal.SALIDA_EFECTIVO) }} <br />
                  </div>
                  <div v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 1">
                    {{ formateaMoneda(0) }} <br />
                  </div>
                  Sucursal: {{ objetoInfoCorteDeCajaSucursal.SUCURSAL }} <br />
                  Fecha: {{ objetoInfoCorteDeCajaSucursal.FECHA }} <br />
                  <div v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 1">
                    Fecha y hora de corte: {{ objetoInfoCorteDeCajaSucursal.FECHA_HORA_CORTE }}
                    <br />
                  </div>
                  <div style="color:orange;" v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 0">
                    Estado: Corte pendiente de realizar.
                  </div>
                  <div style="color:green;" v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 1">
                    Estado: Corte realizado con éxito.
                  </div>
                </span>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              ><v-text-field
                v-if="objetoInfoCorteDeCajaSucursal.ESTADO == 0"
                outlined
                autofocus
                @focus="$event.target.select()"
                label="Salida de dinero"
                v-model="salidaDinero"
                clearable
              ></v-text-field>
              <v-btn color="blue darken-1" @click="$emit('cerrar-modal-corte-caja')" block dark
                >EXCEL CON ENVIOS DEL DÍA</v-btn
              >
            </v-col>
          </v-row>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" @click="$emit('cerrar-modal-corte-caja')" text
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" @click="realizarCorteDeCaja()" text>Aceptar</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import _ from "lodash";
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
import { mapState, mapActions } from "vuex";
export default {
  name: "CorteDeCaja",
  data: () => ({ salidaDinero: 0 }),
  computed: {
    ...mapState({
      logedInUserInfo: state => state.sesion.logedInUserInfo,
      objetoInfoCorteDeCajaSucursal: state => state.cortesDeCaja.objetoInfoCorteDeCajaSucursal
    })
  },
  methods: {
    ...mapActions("cortesDeCaja", ["getEfectivoCaja", "hacerCorteDeCaja"]),
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    },
    async realizarCorteDeCaja() {
      if (this.objetoInfoCorteDeCajaSucursal.ESTADO == 0) {
        if (this.idParaCorteDeCaja == 0) {
          const res = await this.hacerCorteDeCaja({
            Salida: this.salidaDinero,
            idSucursal: this.logedInUserInfo.sucursal
          });
          if (res[0]) {
            this.$emit("muestra-dialog-exito");
          }
        } else {
          const res = await this.hacerCorteDeCaja({
            Salida: this.salidaDinero,
            idSucursal: this.idParaCorteDeCaja
          });
          if (res[0]) {
            this.$emit("muestra-dialog-exito");
          }
        }
      } else {
        this.$emit("cerrar-modal-corte-caja");
        return;
      }
    }
  },
  async mounted() {
    if (this.idParaCorteDeCaja == 0) {
      await this.getEfectivoCaja(this.logedInUserInfo.sucursal);
    } else {
      await this.getEfectivoCaja(this.idParaCorteDeCaja);
    }
  },
  props: {
    show: Boolean,
    idParaCorteDeCaja: Number
  }
};
</script>
